import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-staticaging-vertical',
  standalone: false,
  templateUrl: './static-aging-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class StaticAgingVerticalComponent{
@Input() staticAgingTest:any;
}
